export interface FileValidatorOptions {
  maxSizeInBytes?: number;
  allowedFileExtensions?: string[];
}

export class FileValidator {
  constructor(public options: FileValidatorOptions) {}

  public static create(options: FileValidatorOptions): FileValidator {
    return new FileValidator(options);
  }

  validate(file: File): Error | null {
    const fileExtension = file.name.split('.').pop()?.toLocaleLowerCase() ?? '';
    const allowedExtensions =
      this.options.allowedFileExtensions?.map((e) => e.toLocaleLowerCase()) ?? [];

    if (file.size === 0) {
      return new Error('File is empty.');
    }
    if (allowedExtensions.length > 0 && !allowedExtensions.includes(fileExtension)) {
      return new Error(`Invalid file type. Allowed file types: ${allowedExtensions.join(',')}`);
    }
    if (this.options.maxSizeInBytes != null && file.size > this.options.maxSizeInBytes) {
      return new Error(`Maximum allowed file size is ${this.options.maxSizeInBytes} bytes.`);
    }
    return null;
  }
}
